import { Clock, Eye, Target, User, X } from 'lucide-react';

import { PRIMARY_ORANGE } from '../../../../constants/theme';
import './RevisionHistoryModal.scss';

const RevisionHistoryModal = ({
  isOpen,
  onClose,
  competencyName,
  employeeName,
  selfScore,
  requestedScore,
  expectedScore,
}) => {
  if (!isOpen) return null;

  const entries = [
    {
      type: 'self',
      label: 'Autoavaliação',
      score: selfScore,
      icon: <User className="w-4 h-4" />,
      color: 'text-white',
    },
    ...(requestedScore !== undefined && requestedScore !== null
      ? [{
        type: 'manager',
        label: 'Revisão do Gestor',
        score: requestedScore,
        icon: <Eye className="w-4 h-4" />,
        color: PRIMARY_ORANGE,
      }]
      : []),
    ...(expectedScore !== undefined && expectedScore !== null
      ? [{
        type: 'expected',
        label: 'Nota Esperada',
        score: expectedScore,
        icon: <Target className="w-4 h-4" />,
        color: '#4ade80', // green
      }]
      : []),
  ];

  return (
    <div className="revision-history-modal-overlay" onClick={onClose}>
      <div
        className="revision-history-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="revision-history-modal-header">
          <div className="title-area">
            <h2>
              <Clock />
              <span>Histórico de Revisões</span>
            </h2>
            <p>{employeeName} — {competencyName}</p>
          </div>
          <button onClick={onClose} className="close-button">
            <X />
          </button>
        </div>

        <div className="revision-history-modal-list">
          {entries.map((entry) => (
            <div key={entry.type} className="revision-history-modal-entry">
              <div className="entry-info">
                <div className="entry-icon" style={{ color: entry.color === 'text-white' ? 'white' : entry.color }}>
                  {entry.icon}
                </div>
                <div className="entry-details">
                  <p className="entry-label" style={{ color: entry.color === 'text-white' ? 'white' : entry.color }}>
                    {entry.label}
                  </p>
                </div>
              </div>
              <span className="entry-score" style={{ color: entry.color === 'text-white' ? 'white' : entry.color }}>
                {entry.score}
              </span>
            </div>
          ))}
        </div>

        <div className="revision-history-modal-footer">
          <button onClick={onClose} className="btn-close">
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
};

export default RevisionHistoryModal;
